/* unplugin-vue-components disabled */import { render } from "./Echart.vue?vue&type=template&id=bc96344a&scoped=true&ts=true"
import script from "./Echart.vue?vue&type=script&lang=ts"
export * from "./Echart.vue?vue&type=script&lang=ts"

import "./Echart.vue?vue&type=style&index=0&id=bc96344a&lang=scss&scoped=true"

import exportComponent from "E:\\JMServerCloud\\people-card-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc96344a"]])

export default __exports__